import React from "react";

const Loader = ({ message = "Loading..." }) => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
      <p className="text-slate-200 text-lg">{message}</p> {/* Added text color and size */}
    </div>
  );
};

export default Loader;
